export default __webpack_public_path__ + "static/media/map.60b47aba.jpg";